import React from 'react';
const styles = require('./styles/styles.scss')
import Store from '../store/store'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import InputLabel from "@material-ui/core/InputLabel";
import { withRouter, RouteComponentProps } from "react-router";
import { observer } from "mobx-react";
import Spinner from '../Spinner/Spinner';
import { DialogFooter, DialogType, Dialog as DialogFabric } from "office-ui-fabric-react/lib/Dialog";
import { PrimaryButton, DefaultButton } from "office-ui-fabric-react/lib/Button";

interface Props {
}

interface State {
  tempValueDateFinSouhaitee?: Date;
  loadingButton: boolean;
  autoCalculModalIsHidden:boolean;
}

@observer
class EditDateFinSouhaitee extends React.Component<RouteComponentProps & Props, State>{

  public constructor(props: RouteComponentProps & Props) {
    super(props)
    this.state = {
      tempValueDateFinSouhaitee: Store.workflow.dateFinSouhaitee,
      loadingButton: false,
      autoCalculModalIsHidden:true
    }
  }

  public onChange = e => {
    this.setState({
      tempValueDateFinSouhaitee: e.target.value
    })
  }

  public convertDateFromDataBaseToDisplaying = (date) => {
    //    return "2020-02-21"
    const newDate = new Date(date)
    if ((newDate.getMonth() + 1) < 10) {
      if (newDate.getDate() < 10) {
        return newDate.getFullYear() + "-0" + (newDate.getMonth() + 1) + "-0" + newDate.getDate()
      }
      else {
        return newDate.getFullYear() + "-0" + (newDate.getMonth() + 1) + "-" + newDate.getDate()
      }
    } else {
      if (newDate.getDate() < 10) {
        return newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-0" + newDate.getDate()
      }
      else {
        return newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate()
      }
    }
  }

  public onValidDateFinSouhaitee = () => {
    this.setState({ loadingButton: true }, () => {
      const today = new Date();
      axios.post(Store.wsPath + '/1/workflows/validDateSouhaitee', {
        idProject: Store.workflow.id,
        dateFinSouhaitee: this.state.tempValueDateFinSouhaitee != undefined && this.state.tempValueDateFinSouhaitee != null ?this.state.tempValueDateFinSouhaitee  :today
      }).then((response) => {
        this.setState({ loadingButton: false });
        Store.snackBar = {
          open: true,
          error: false,
          message: "La date de fin a été modifiée"
        };
        Store.contextualmenu = {
          content: "ActionsWorkflow",
          open: "open"
        };
        // Store.reloadWorkFlow = true;
        // Store.workflow.dateFinSouhaitee = this.state.tempValueDateFinSouhaitee;
        this.props.history.push("/refresh?redir=document?w=" + Store.workflow.id);
      }).catch(error => {
        console.error("Error 'onValidDateFinSouhaitee' : ", error);
        this.setState({ loadingButton: false });
        Store.snackBar = {
          open: true,
          error: true,
          message: "Une erreur est survenue lors de la modification de la date de fin"
        };
      });
    });
  }
  public onValidAutoCalcul = () => {
    this.setState({ autoCalculModalIsHidden: true }, () => {
      axios.post(Store.wsPath + '/1/workflows/autoCalculEndDate', {
        idProject: Store.workflow.id
      }).then((response) => {
        Store.snackBar = {
          open: true,
          error: false,
          message: "La date de fin a été modifiée"
        };
        Store.contextualmenu = {
          content: "ActionsWorkflow",
          open: "open"
        };
        // Store.reloadWorkFlow = true;
        // Store.workflow.dateFinSouhaitee = this.state.tempValueDateFinSouhaitee;
        this.props.history.push("/refresh?redir=document?w=" + Store.workflow.id);
      }).catch(error => {
        console.error("Error 'onValidAutoCalcul' : ", error);
        Store.snackBar = {
          open: true,
          error: true,
          message: "Une erreur est survenue lors de la modification de la date de fin"
        };
      });
    });
  }
  public openCloseAutoCalculModal = (open: boolean,) => event => {
    if (open == true) {
        this.setState({ autoCalculModalIsHidden: false });
    }
    else {
        this.setState({ autoCalculModalIsHidden: true});
    }
}
  public render() {
    const todayDate = new Date();
    return (
      <div>
        <p style={{fontSize:"17px"}}>Modification de la date de fin</p>
        <div>
          <InputLabel>Définie manuellement</InputLabel>
          <TextField
            variant='outlined'
            id="date"
            type="date"
            className={styles.field}
            required
            defaultValue={this.state.tempValueDateFinSouhaitee != undefined && this.state.tempValueDateFinSouhaitee != null ?this.convertDateFromDataBaseToDisplaying(this.state.tempValueDateFinSouhaitee) :this.convertDateFromDataBaseToDisplaying(todayDate)}
            InputLabelProps={{ shrink: true }}
            onChange={this.onChange}
          />
        </div>
        <div style={{ marginTop: "10px" ,marginBottom:"10px"}}>
          <Button onClick={this.onValidDateFinSouhaitee} type="submit" variant="contained" color="primary" style={{fontSize:"12px"}} disabled={this.state.loadingButton}>
            {
              this.state.loadingButton == true ?
                <Spinner className={styles.icon} size={24} />
                :
                "Enregistrer"
            }
          </Button>
        </div>
        <div className={styles.hr}>Ou</div>
        <div style={{ marginTop: "10px" }}>
          <Button onClick={this.openCloseAutoCalculModal(true)} type="submit" variant="contained" color="primary" style={{fontSize:"12px"}} disabled={this.state.loadingButton}>
            Calculée automatiquement
          </Button>
          <DialogFabric
            hidden={this.state.autoCalculModalIsHidden}
            onDismiss={this.openCloseAutoCalculModal(false)}
            dialogContentProps={{
                type: DialogType.normal,
                title: "Calculer automatiquement la date de fin",
                closeButtonAriaLabel: 'Fermer',
            }}
            modalProps={{
                isBlocking: true
            }}
          >
            <React.Fragment>
              <p>Le calcul automatique de la date de fin prend en compte les informations suivantes:</p>
              <ul>
                <li>Date de début du circuit</li>
                <li>Poids des tâches</li>
              </ul>
              <DialogFooter>
                <PrimaryButton onClick={this.onValidAutoCalcul} text="Confirmer" />
                <DefaultButton onClick={this.openCloseAutoCalculModal(false)} text="Annuler" />
              </DialogFooter>
            </React.Fragment>
          </DialogFabric>
        </div>
      </div>
    )
  }
}

export default withRouter(EditDateFinSouhaitee);